import { ABSOLUTE_ROOT_PATH } from '../../constants';
import { SeoMetaTags } from '../../../shared/types';

export const calculateArticleLink = ({ seo }: { seo: SeoMetaTags }) => seo.pageUrl.split('fiverr.com')[1];

export const calculateCategoryLink = ({ handle }: { handle: string }) =>
    `${ABSOLUTE_ROOT_PATH}/${handle.split('/')[1]}`;

export const prefixFields = (fields: string[], prefix: string) => fields.map((field) => `${prefix}.${field}`).join(',');

const isFiverrUrl = (url: string) => url.includes('fiverr.com') || url.startsWith('/');
const isExternalUrl = (url: string) => !(url.includes('fiverr.com/resources') || url.startsWith('/resources'));

export const getLinkAttributes = (url?: string): { target?: string; rel?: string } => {
    if (!url || !isExternalUrl(url)) return {};
    return {
        target: '_blank',
        rel: isFiverrUrl(url) ? 'noopener' : 'nofollow noopener',
    };
};
